import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ShowController, ReferenceField, TextField } from 'react-admin';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import ErrorBoundary from '../ErrorBoundary';




const ShipmentShow = props => (
    <ErrorBoundary>  
    <ShowController {...props} title=" ">
        {({ record }) =>
            record && (
                <Card style={{  margin: 'auto'}}>
                    <CardContent>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                <Typography variant="subheading" gutterBottom style={{color: 'blue'}}>
                                <b>Name:&nbsp;</b> {record.name}  <br/><b>SSN:&nbsp;</b>{record.ssn} &nbsp;&nbsp;&nbsp;<b>Gender:&nbsp;</b>{record.gender}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="left"
                                >
                                <b>Amount:</b> ${record.amount}  |  <b>Volume:</b> {record.volume}  |   <b>Pay mode:</b> {record.payment_mode}
                                </Typography>
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="left"
                                >
                               <b>Comments:</b> {(record.comments)?record.comments: '-'}
                                </Typography> 
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="left"
                                >
                               <b>Management Initial:</b> {record.mgmt_initial}  |  <b>Management Date:</b> { (record.mgmt_date)? moment(record.mgmt_date).format('MM/DD/YYYY'):'' }  
                                </Typography>  
                                <Typography
                                    variant="body1"
                                    gutterBottom
                                    align="left"
                                >
                              <b>Ready to ship:</b> {record.ready_to_ship}    |    <b>QA Initial:</b> {record.qa_initial}
                                </Typography>  
                            </Grid>
                        </Grid>
                    </CardContent>
               
                    <Table   style={{ margin: 'auto',  fontSize:'12px' , width:"100%"}} >  
                    <TableHead style={{backgroundColor: 'grey', color: 'white'}}>
                    <TableRow>
                        <TableCell style={{color: 'white'}} align="center">HBS</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HCV</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HIV</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HAV NAT</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HBV NAT</TableCell>
                        <TableCell style={{color: 'white'}} align="center">HCV NAT</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>                 
                        <TableRow >
                        <TableCell align="center">{record.hbs}</TableCell>
                        <TableCell align="center">{record.hcv}</TableCell>
                        <TableCell align="center">{record.hiv}</TableCell>
                        <TableCell align="center">{record.hav_nat}</TableCell>
                        <TableCell align="center">{record.hbv_nat}</TableCell>
                        <TableCell align="center">{record.hcv_nat}</TableCell>                       
                        </TableRow>
                    </TableBody>
                    <TableHead style={{backgroundColor: 'grey', color: 'white'}}>
                    <TableRow>
                        <TableCell style={{color: 'white'}} align="center">HIV NAT</TableCell>                      
                        <TableCell style={{color: 'white'}} align="center">PARVO NAT</TableCell>
                        <TableCell style={{color: 'white'}} align="center">SPE</TableCell>
                        <TableCell style={{color: 'white'}} align="center">RPR</TableCell>
                        <TableCell style={{color: 'white'}} align="center">ABY</TableCell>
                        <TableCell style={{color: 'white'}} align="center"></TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>                 
                        <TableRow >                       
                        <TableCell align="center">{record.hiv_nat}</TableCell>
                        <TableCell align="center">{record.parvo_nat}</TableCell>
                        <TableCell align="center">{record.spe}</TableCell>
                        <TableCell align="center">{record.rpr}</TableCell>
                        <TableCell align="center">{record.aby}</TableCell>
                        <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
              </Card>
            )
        }
    </ShowController>
    </ErrorBoundary>  
);

export default ShipmentShow;
